import React, { useEffect } from 'react';
import { useQuery } from 'react-apollo';
import useStyles from 'isomorphic-style-loader/useStyles';
import Lenis from 'lenis';
import s from './Home.css';
import Loader from '../../components/Common/Loader';

// Sections
import Hero from './sections/Hero/Hero';
import Stats from './sections/Stats/Stats';
import About from './sections/About/About';
import OurServices from './sections/OurServices/OurServices';
import OurServiceArea from './sections/OurServiceArea/OurServiceArea';
import Partners from './sections/Partners/Partners';
import Testimonials from './sections/Testimonials/Testimonials';
import WhyChooseUs from './sections/WhyChooseUs/WhyChooseUs';
import DownloadApp from './sections/DownloadApp/DownloadApp';
import Faq from './sections/Faq/Faq';
import News from './sections/News/News';
import SafestPlatform from './sections/SafestPlatform/SafestPlatform';
import CtaBanner from './sections/CtaBanner/CtaBanner';
import HowItWorks from './sections/HowItWorks/HowItWorks';

// Graphql
import getAllHomePageSettings from './getAllHomePageSettings.graphql';

function Home() {
  useStyles(s);
  const { loading } = useQuery(getAllHomePageSettings, { ssr: true });

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    const rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  if (loading) return <Loader type="text" />;

  return (
    <div className={s.homepage}>
      <Hero />
      <Stats />
      <About />
      <OurServices />
      <OurServiceArea />
      <HowItWorks />
      <Partners />
      {/* <Testimonials /> */}
      <Faq />
      {/* <SafestPlatform/> */}
      <News />
    </div>
  );
}

export default Home;
